<script setup>
import { computed, provide } from 'vue'
const props = defineProps({
  checked: null, // any type
  modelValue: null, // any type
  options: {
    type: Array
  },
  switches: {
    type: Boolean,
    default: false
  },
  stacked: {
    type: Boolean,
    default: true
  },
  valueField: {
    type: String
  },
  textField: {
    type: String
  }
})

const emit = defineEmits(['update:modelValue', 'change', 'input'])

const localModel = computed({
  get: () => props.modelValue ?? props.checked,
  set: (val) => {
    emit('update:modelValue', val)
  }
})

const setParentModel = (val) => {
  localModel.value = val
  emit('updated', val)
  emit('change', val)
}

provide('parentModel', localModel)
provide('setParentModel', setParentModel)

const resolveValue = (option) => {
  if (option?.hasOwnProperty(props.valueField)) {
    return option[props.valueField]
  }
  if (option?.hasOwnProperty('value')) {
    return option.value
  }
  return option
}

const resolveText = (option) => {
  if (option?.hasOwnProperty(props.textField)) {
    return option[props.textField]
  }
  if (option?.hasOwnProperty('text')) {
    return option.text
  }
  return option
}

const handleInput = ($event) => {
  emit('updated', $event)
}

const handleChange = ($event) => {
  emit('change', $event)
}
</script>

<template>
  <div :class="!stacked ? 'd-flex flex-wrap' : undefined">
    <slot name="default">
      <t-checkbox
        v-for="(option, index) in options"
        :key="`option-${index}`"
        v-model="localModel"
        :name="resolveText(option)"
        :value="resolveValue(option)"
        :switch="switches"
        :disabled="option.disabled"
        :binary="false"
        class="mb-2"
        :class="!stacked ? 'pr-2' : undefined"
        @updated="handleInput"
        @change="handleChange"
      >
        {{ resolveText(option) }}
      </t-checkbox>
    </slot>
  </div>
</template>
